// src/api/endpoints.js
export const API_ENDPOINTS = {
    REGISTER: "/api/v1/accounts/signup",                     // sign-up
    VERIFY_EMAIL: "/api/v1/accounts/verify-email",           // email verification (email + otp)
    RESEND_OTP: "/api/v1/accounts/resend-otp",               // Resend Otp (email)

    LOGIN: "/api/v1/auth/login",                             // login (username + password)
    LOGOUT: "/api/v1/auth/logout",
    FORGOT_PASSWORD: "/api/v1/auth/password-reset/request",  // request password reset (email)
    RESET_PASSWORD: "/api/v1/auth/password-reset/execute",    // execute password reset (email + otp + newPassword)
    ME: '/api/v1/auth/me', //Me Info
    REFRESH_TOKEN: "/api/v1/auth/refresh",
    OCR_EXTRACT: "/api/v1/ocr/extract",
    OCR_EXTRACT_STREAM: "/api/v1/ocr/extract-stream",
    OCR_PROCESS: "/api/v1/ocr/process",
    OCR_COPY: "/api/v1/ocr/copy",
    OCR_ALIGN: "/api/v1/ocr/align-template",
    OCR_TEMPLATES: "/api/v1/templates",
    BANK_OAUTH_START_URL: "/api/bank/oauth/start-url",
    UPGRADE_FULL_TRIAL: "/api/v1/accounts/upgrade-full-trial",
    BILLING_PROFILE: "/api/v1/accounts/billing-profile",
    POSTAL_CODE_LOOKUP: "/api/v1/address/postal-code",
    BILLING_INVOICES: "/api/v1/billing/invoices",
    BILLING_QUOTE: "/api/v1/billing/quote",
    BILLING_RECONCILE: "/api/v1/billing/reconcile",
    MODELS: "/api/v1/ocr/models",
    OCR_UI_CONFIG: "/api/v1/ocr/ui-config",
    PLANS: "/api/v1/plans",
    ORGANIZATION_MEMBERSHIPS: "/api/v1/organizations/memberships",
    ORGANIZATION_INVITATIONS: "/api/v1/organizations/memberships/invitations",
    PENDING_INVITATIONS: "/api/v1/organizations/memberships/invitations/pending",
    ORGANIZATION_CREDIT_REQUESTS: "/api/v1/organizations/credit-requests",
};
